<!--
- 工作台 WorkBench
- 创建人: wang.y
- 创建时间: 2020-06-01 Happy children's Day
-->
<template lang="html">
  <div class="work-bench">
    <div class="bench-left">
      <div ref="content-left" class="content-left">
        <div class="bench-page">
          <h1>我的关注</h1>
          <div class="attention-list">
            <Checkbox v-model="check_all" @on-change="handleCheckAll">
              <span>全部关注</span>
            </Checkbox>
            <CheckboxGroup v-model="feed_type" @on-change="handleChangeType">
              <Checkbox label="tag">
                <span>关注的领域 ({{atten_num(2)}})</span>
              </Checkbox>
              <Checkbox label="comp">
                <span>关注的公司 ({{atten_num(0)}})</span>
              </Checkbox>
              <Checkbox label="org">
                <span>关注的金融机构 ({{atten_num(1)}})</span>
              </Checkbox>
              <!-- 自定义分组 -->
              <Checkbox
                v-for = "item,index in attention.group"
                :key= "index"
                :label="'g|' +item.id"
              >
                <span>{{item.name}} ({{group_num(item.id)}})</span>
              </Checkbox>
              <!-- 热门分组 -->
              <Checkbox
                v-for = "item,index in zt_list"
                :key= "'zt' + index"
                :label="'zt|' +item.id"
              >
                <span>{{item.name}} ({{item.entitys.length}})</span>
              </Checkbox>
              <!-- 值得关注 -->
              <Checkbox
                v-for = "item,index in yz_group"
                :key= "'yz' + index"
                :label="'yz|' + item.id"
              >
                <span>{{item.name}} ({{item.org.length + item.comp.length}})</span>
              </Checkbox>
              <!-- <span class="more_sel" @click="type_show = !type_show" v-if="attention.group && attention.group.length+zt_list.length > 2">
                <template v-if="!type_show">查看更多</template>
                <template v-else>收起更多</template>
              </span> -->
            </CheckboxGroup>
          </div>
          <a @click="haddleSetAtten1()" class="add-atten">添加关注 <i class="iconfont">&#xe72c;</i></a>
        </div>
        <div class="bench-page">
          <h1>我的收藏</h1>
          <div class="collect-list">
            <div @click="handleChangeRouter('UserCollect', {type: '0'})">
              <img :src="static_img_url + (!theme_switch ? 'pic/workbebch/topic_d.png' : 'pic/workbebch/topic_l.png')" />
              <p>快讯<span v-if="collect.length > 0">({{collect[0].num}})</span></p>
            </div>
            <div @click="handleChangeRouter('UserCollect', {type: '2'} )">
              <img :src="static_img_url + (!theme_switch ? 'pic/workbebch/theme_d.png' : 'pic/workbebch/theme_l.png')" />
              <p>专题<span v-if="collect.length > 0">({{collect[2].num}})</span></p>
            </div>
            <div @click="handleChangeRouter('UserCollect', {type: '1'} )">
              <img :src="static_img_url + (!theme_switch ? 'pic/workbebch/rep_d.png' : 'pic/workbebch/rep_l.png')" />
              <p>报告<span v-if="collect.length > 0">({{collect[1].num}})</span></p>
            </div>
            <div @click="handleChangeRouter('UserCollect', {type: '4'} )">
              <img :src="static_img_url + (!theme_switch ? 'pic/workbebch/art_d.png' : 'pic/workbebch/art_l.png')" />
              <p>文章<span v-if="collect.length > 0">({{collect[4].num}})</span></p>
            </div>
            <div @click="handleChangeRouter('UserCollect', {type: '3'} )">
              <img :src="static_img_url + (!theme_switch ? 'pic/workbebch/policy_d.png' : 'pic/workbebch/policy_l.png')" />
              <p>政策<span v-if="collect.length > 0">({{collect[3].num}})</span></p>
            </div>
          </div>
        </div>
        <div class="bench-page">
          <h1>浏览记录</h1>
          <div class="history">
            <div class="history-item" v-for="item,index in history_list" :key="index" v-if="history_list.length">
              <div class="logo_img" @click="goEntityDetail(item.uid, item.type)"><img :src="item.logo_path | logo_show"></div>
              <div class="entity-name" @click="goEntityDetail(item.uid, item.type)">{{item.short_name}}</div>
              <div class="atten">
                <span class="spa1" v-if="!is_atten(item.id)" @click="attentionAdd(item.id, item.type)"><i class="iconfont">&#xe64a;</i>关注</span>
                <Dropdown v-else class="cancel" placement="bottom-start" @on-click="attentionDelete(item.id)">
                  <span class="spa2"><i class="iconfont">&#xe64b;</i>已关注</span>
                  <DropdownMenu slot="list">
                    <DropdownItem>取消关注</DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </div>
            </div>
            <p class="history-none"  v-if="history_list.length == 0">暂无浏览记录，前去<span @click="handleChangeRouter('CompanyList')">查看</span></p>
          </div>
        </div>
      </div>
    </div>
    <div class="bench-center">
      <div class="bench-page" v-if="feed_type.length == 0 && !check_all" style="margin-bottom: 16px">
        <h1>热门推荐</h1>
        <div class="search-ipt">
          <Input
            v-model="search_key"
            placeholder="添加您关注的企业"
            @on-change="handleChangeSearch"
            @on-focus="search_list_show = true"
            @on-blur="handleFocusSearch"
          >
            <i class="iconfont" slot="prefix">&#xe6d7;</i>
          </Input>
          <div class="search-list" v-if="search_key && search_list_show">
            <div class="search-tip" v-if="search_list.length == 0 && !search_loading">
              <div class="nothing">
                <div class="img"></div>
                <p>没有找到相关的内容<br><span @click="haddleBackModel">我要反馈</span></p>
              </div>
            </div>
            <div class="search-loading" v-if="search_loading">
              <Spin fix>
                <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
                <div>Loading</div>
              </Spin>
            </div>
            <div class="search-cnt" v-if="search_list.length > 0 && !search_loading">
              <div class="search-item" v-for="item,index in search_list" :key="index">
                <div class="logo_img" @click="goEntityDetail(item.uid, item.type)"><img :src="item.logo_path | logo_show"></div>
                <div class="entity-name" @click="goEntityDetail(item.uid, item.type)">
                  <div>
                    <p class="p1" v-html="filter.keyWordHighLight(item.short_name, search_key)"></p>
                    <p class="p2">{{item.description}}</p>
                  </div>
                </div>
                <div class="atten">
                  <span class="spa1" v-if="!is_atten(item.id)" @click="attentionAdd(item.id, item.type)"><i class="iconfont">&#xe64a;</i>关注</span>
                  <Dropdown v-else class="cancel" placement="bottom-start" @on-click="attentionDelete(item.id)">
                    <span class="spa2"><i class="iconfont">&#xe64b;</i>已关注</span>
                    <DropdownMenu slot="list">
                      <DropdownItem>取消关注</DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="hot-list">
          <swiper :options="swiperOption" ref="mySwiper">
            <template v-for="item,index in hot_list">
              <swiper-slide :key="index" v-if="(((index%4) == num_random && index<4) || (index-num_random)%3 == 0) && ((index-num_random)/3+1) <= zt_list_no.length && zt_list_no.length != 0">
                <div class="hot-item">
                  <div class="hot-i" v-if="zt_list_no[((index%4) == num_random && index<4)?0:(index-num_random)/3].flag_tag == '1'"> <i class="iconfont">&#xe6d1;</i> </div>
                  <div class="logo_img">
                    <img :src="zt_list_no[((index%4) == num_random && index<4)?0:(index-num_random)/3].logo_path | logo_show" />
                  </div>
                  <p class="name">#{{zt_list_no[((index%4) == num_random && index<4)?0:(index-num_random)/3].name}}</p>
                  <div class="summary"><p>{{zt_list_no[((index%4) == num_random && index<4)?0:(index-num_random)/3].description}}</p></div>
                  <Button @click="handleZtAtten(zt_list_no[((index%4) == num_random && index<4)?0:(index-num_random)/3])">+ 添加关注</Button>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="hot-item">
                  <div class="logo_img">
                    <img :src="item.logo_path | logo_show" />
                  </div>
                  <p class="name">{{item.short_name}}</p>
                  <div class="summary"><p>{{item.description}}</p> <div @click="goEntityDetail(item.uid, item.type)">查看详情</div> </div>
                  <Button v-if="!is_atten(item.id)" @click="handleHotAtten(item, index)">+ 添加关注</Button>
                  <Button class="on" v-else @click="attentionDelete(item.id)">已关注</Button>
                </div>
              </swiper-slide>
            </template>
          </swiper>
          <div class="prev-btn">
            <div class="hot-msk"></div>
            <Button><i class="iconfont">&#xe72d;</i></Button>
          </div>
          <div class="next-btn">
            <div class="hot-msk"></div>
            <Button><i class="iconfont">&#xe72c;</i></Button>
          </div>
        </div>
      </div>
      <div class="my-feed">
        <h1 v-if="all_option && all_option.length > 0">我的Feed流</h1>
        <div class="sel_opt" v-if="all_option && all_option.length > 0">
          <div class="sel_cnt">
            <span v-for="(item,index) in all_option" :key="index" @click="haddleCloseOpt(item)">{{item.name}}
              <Icon type="md-close" />
            </span>
          </div>
          <div class="sel_clear">
            <span @click="haddleClearOpt"><i class="iconfont">&#xe63e;</i>清空筛选</span>
          </div>
        </div>
        <div v-for="item,index in feed_list" :key="index">
          <a :href="adv_list[0].link | page" class="feed-adv" v-if="index == 3 && adv_list.length > 0" target="_blank">
            <span>广告</span>
            <img :src="adv_list[0].img_path | logo_show">
          </a>
          <a :href="adv_list[1].link | page" class="feed-adv" v-if="index == 6 && adv_list.length > 1" target="_blank">
            <span>广告</span>
            <img :src="adv_list[1].img_path | logo_show">
          </a>
          <div class="feed-item">
            <div class="feed-top" v-if="item[0].card_type == 2">
              <div class="logo_img" style="border: 0" @click="handleClickMoreFeed(item[0].c_id, item[0].card_type)">
                <img :src="static_img_url + 'pic/workbebch/feed-tag-icon.png'">
              </div>
              <div class="feed-info">
                <div class="feed-name" @click="handleClickMoreFeed(item[0].c_id, item[0].card_type)">{{item[0].app_layer_tag_name}}</div>
                <div class="feed-time">{{item[0].date_day}}</div>
              </div>
            </div>
            <div class="feed-top" v-else>
              <div class="logo_img" @click="goEntityDetail(item[0].entity_uid, item[0].card_type)">
                <img :src="item[0].entity_logo_path | logo_show">
              </div>
              <div class="feed-info">
                <div class="feed-name" @click="goEntityDetail(item[0].entity_uid, item[0].card_type)">{{item[0].entity_short_name}}</div>
                <div class="feed-time">{{item[0].date_day}}</div>
              </div>
            </div>
            <span class="span spa1" v-if="!is_atten(item[0].c_id)" @click="attentionAdd(item[0].c_id, item[0].card_type)"><i class="iconfont">&#xe64a;</i>关注</span>
            <Tooltip class="feed-tool" v-else>
              <i class="iconfont">&#xe681;</i>
              <div class="tool-content" slot="content">
                <div class="atten">
                  <!-- <span class="spa1" v-if="!is_atten(item[0].c_id)" @click="attentionAdd(item[0].c_id, item[0].card_type)"><i class="iconfont">&#xe64a;</i>关注</span> -->
                  <span class="spa2" @click="attentionDelete(item[0].c_id)"><i class="iconfont">&#xe64b;</i>取消关注</span>
                </div>
              </div>
            </Tooltip>
            <div class="feed-list">
              <div class="feed-li" v-for="item2,index2 in item" :key="index2" v-if="index2 < 3">
                <div class="feed-type-1" v-if="item2.content_type == 1 || item2.content_type == 2 || item2.content_type == 4 || item2.content_type == 5">
                  <div class="info-img" @click="goDetail(item2.content_uid, item2.content_type, item2.forum_src_url, item2.content_id)">
                    <span class="tag" v-if="item2.content_type == 1">报告</span>
                    <span class="tag" v-if="item2.content_type == 2">专题</span>
                    <span class="tag" v-if="item2.content_type == 4">文章</span>
                    <span class="tag" v-if="item2.content_type == 5">活动</span>
                    <img :src="item2.content_logo_path | logo_show">
                  </div>
                  <div class="info-content">
                    <div>
                      <div class="p1" @click="goDetail(item2.content_uid, item2.content_type, item2.forum_src_url, item2.content_id)" v-html="item2.content_title"></div>
                      <div class="p2" v-if="item2.content_type == 2 && item2.latest_content_of_theme.length" v-html="'更新：'+ item2.latest_content_of_theme[0].title"></div>
                      <div class="p2" v-if="item2.content_type == 1">{{item2.content_price > 0 ? '付费' : '免费'}}</div>
                      <div class="p2" v-if="item2.content_type == 4">{{item2.content_src_name ? item2.content_src_name : '动脉网'}}</div>
                      <div class="p2" v-if="item2.content_type == 5">{{item2.content_address_id | deal('address')}}</div>
                    </div>
                  </div>
                </div>
                <div class="feed-type-2" v-if="item2.content_type == 0 || item2.content_type == 3">
                  <!-- <span class="tag tag1" v-if="item2.content_type == 0">快讯</span> -->
                  <!-- <span class="tag tag2" v-if="item2.content_type == 3">政策</span> -->
                  <p @click="goDetail(item2.content_uid, item2.content_type, item2.forum_src_url, item2.content_id)" :class="{'on': is_show(item2.content_id, item2.content_type, item2.c_id, item2.date_day)}">
                    <span class="topic-type" v-if="item2.content_type == 0">
                      <i v-for="tag_item in item2.content_topic_type" :key="tag_item.id">{{tag_item.name}}</i>
                    </span>{{item2.content_title}}
                  </p>
                  <span class="show-tag" @click="handleClickShow(item2.content_id, item2.content_type, item2.c_id, item2.date_day)">
                    <template v-if="!is_show(item2.content_id, item2.content_type, item2.c_id, item2.date_day)">展开<i class="iconfont">&#xe648;</i></template>
                    <template v-else>收起<i class="iconfont">&#xe63b;</i></template>
                  </span>
                </div>
                <div class="show-all" v-if="(item2.content_type == 0 || item2.content_type == 3) && is_show(item2.content_id, item2.content_type, item2.c_id, item2.date_day)">
                  <div class="f-cnt" v-if="item2.content_type == 0">
                    <span v-if="item2.content_summary">{{item2.content_summary}}</span>
                    <a v-if="item2.content_topic_src" :href="item2.content_topic_src" class="src-link" target="_blank">阅读原文
                      <i class="iconfont">&#xe72c;</i>
                    </a>
                  </div>
                  <div class="policy-info" v-if="item2.content_type == 3">
                    <div class="policy-items">
                      <div class="policy-item"><div>发文机关：</div><div>{{item2.policy_publish_org | empty}}</div></div>
                      <div class="policy-item"><div>发文字号：</div><div>{{item2.policy_code | empty}}</div></div>
                      <div class="policy-item"><div>发文时间：</div><div>{{item2.c_publish_time | time_moment}}</div></div>
                      <div class="policy-item"><div>有效地区：</div><div>{{item2.policy_address_id | addressDeal('3')}}</div></div>
                      <div class="policy-item"><div>时效性：</div><div>{{item2.policy_available | empty}}</div></div>
                      <div class="policy-item"><div>实施时间：</div><div>{{item2.policy_execute_time | time_moment}}</div></div>
                    </div>
                    <a v-if="item2.policy_src_url" :href="item2.policy_src_url" class="src-link" target="_blank">阅读原文
                      <i class="iconfont">&#xe72c;</i>
                    </a>
                  </div>
                  <div class="div-img" v-if="item2 && item2.content_file.length != 0">
                    <img v-for="item3,index3 in item2.content_file" :key="index3" :preview="item2.content_id" :src="item3.path | logo_show">
                  </div>
                  <div style="margin-top: 8px; position: relative">
                    <div class="tag-list" v-if="item2 && item2.content_entity.length != 0">
                      <i class="iconfont">&#xe660;</i>
                      <template v-for="item3,index3 in item2.content_entity">
                        <template v-if="index3 > 0">·</template>
                        <span
                          :key="index3"
                          @click="goEntityDetail(item3.uid, item3.type)"
                        >{{item3.short_name}}</span>
                      </template>
                    </div>
                    <div class="spa" :class="{'on': item2.content_type == 0}">
                      <i class="iconfont s active" title="取消收藏" v-if="item2.is_collect == 1" @click="cancelCollect(item2.content_type, item2.content_id, changeCollect, {type: item2.content_type, id: item2.content_id, status: 0})">&#xe66f;</i>
                      <i class="iconfont s" title="收藏" v-if="item2.is_collect == 0" @click="addCollect(item2.content_type, item2.content_id, changeCollect, {type: item2.content_type, id: item2.content_id, status: 1})">&#xe66f;</i>
                      <Poptip trigger="hover" placement="bottom-end" padding="0" width="248" @on-popper-show="haddleShare(item2.content_uid, item2.content_type)" @on-popper-hide="haddleShareHide">
                        <i class="iconfont w">&#xe641;</i>
                        <div slot="content" class="share_cnt clear">
                          <div class="share_img"></div>
                          <p>打开微信“扫一扫”<br />点击右上角分享按钮</p>
                        </div>
                      </Poptip>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="more" v-if="item.length > 3">
              <span @click="handleClickMoreFeed(item[0].c_id, item[0].card_type)">查看更多“{{item[0].card_type == 2 ? item[0].app_layer_tag_name : item[0].entity_short_name}}”信息<i class="iconfont">&#xe647;</i></span>
            </div>
          </div>
        </div>
        <Nothing v-if="!feed_loading && feed_list == 0">
          <p>亲，暂无信息流更新，您可以尝试关注更多<br><a @click="goAtten()">前往设置</a></p>
        </Nothing>
        <div class="feed-more" @click="handleMoreFeed" v-if="!feed_loading && !feed_end">加载更多</div>
        <div class="feed-loading" v-if="feed_loading">
          <Spin fix>
            <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
            <div>Loading</div>
          </Spin>
        </div>
      </div>
    </div>
    <div class="bench-right">
      <div ref="content-right" class="content-right">
        <div class="bench-page">
          <h1 class="financing-title">
            <span :class="{'on': event_domestic == 1}" @click="handleChangeDomestic(1)">国内融资</span>
            <span :class="{'on': event_domestic == 0}" @click="handleChangeDomestic(0)">国外融资</span>
            <em @click="handleChangeRouter('FinancingIndex')">更多<i class="iconfont">&#xe72c;</i></em>
          </h1>
          <div class="financing">
            <p class="financing-info">
              <i class="iconfont">&#xe72e;</i>
              <span>本周融资：{{week_count}}</span>
              <span>金额：{{week_amount}}亿人民币</span>
            </p>
            <div class="financing-chart" id="financing-chart"></div>
          </div>
        </div>
        <div class="bench-page">
          <h1>近期热门<i>近1个月</i></h1>
          <div class="recent-hot">
            <div class="recent-hot-item">
              <p class="p1">{{hotele['news_topic_num'] | empty('0')}}</p>
              <p class="p2" @click="handleChangeRouter('NewsList')">快讯</p>
            </div>
            <div class="recent-hot-item" @click="">
              <p class="p1">{{hotele['report_num'] | empty('0')}}</p>
              <p class="p2" @click="handleChangeRouter('ReportList')">报告</p>
            </div>
            <div class="recent-hot-item" @click="">
              <p class="p1">{{hotele['theme_num'] | empty('0')}}</p>
              <p class="p2" @click="handleChangeRouter('SpecialList')">专题</p>
            </div>
            <div class="recent-hot-item" @click="">
              <p class="p1">{{hotele['event_num'] | empty('0')}}</p>
              <p class="p2" @click="handleChangeRouter('EventList')">融资事件</p>
            </div>
            <Spin fix v-if="hotele_loading">
              <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
              <div>Loading</div>
            </Spin>
          </div>
        </div>
        <div class="bench-page">
          <h1>明星机构<i>近3个月</i></h1>
          <div class="star">
            <div class="star-item" v-for="item,index in org_top" :key="index">
              <div class="logo_img" @click="goEntityDetail(item.uid, item.type)"><img :src="item.logo_path | logo_show"></div>
              <div class="entity-name" @click="goEntityDetail(item.uid, item.type)">{{item.short_name}}</div>
              <div class="num">{{item.tz_count}}次</div>
            </div>
            <a @click="handleChangeRouter('OrgList')" class="more">查看更多 <i class="iconfont">&#xe72c;</i></a>
          </div>
        </div>
      </div>
    </div>
    <selectIdentity :selectIdentity="select_identity" @identitycancel="identityCancel" :flow="flow"></selectIdentity>
    <Modal
      v-model="identity_cb" 
      width="360"
      class="identity-cb"
      title=""
      @on-visible-change="clearIdentityModal"
      footer-hide>
      <div class="content"> 
        <img :src="static_img_url + 'pic/workbebch/success_icon.png'" alt="">
        <p class="p1">关注成功</p>
        <p class="p2">您可以在我的关注里面进行修改</p>
        <span @click="identity_cb = false">知道了</span>
      </div>
    </Modal>
    <OrgModal ref="org_modal" :imgurl="org_modal_img">
      <p class="p1" slot>{{org_modal_p}}</p>
    </OrgModal>
    <ApplyNow></ApplyNow>
  </div>
</template>

<script>
import { attention_mixins } from "js/attention_mixins";
import { attention_entity_mixins } from "js/attention_entity_mixins";
import { userInfo } from "js/userInfo";
import { collect_mixin } from 'js/collect_mixin'
import {
  myCollectionNum,
  getWeekEvent,
  getHotele,
  getOrgTop,
  recommendEntity,
  searchForEntity,
  addSubscribe,
  findEntity,
  userFeedData,
  advList
} from "../../service";
import SelectIdentity from "@/components/SelectIdentity.vue";
import Nothing from "@/components/Nothing.vue";
import OrgModal from '@/components/OrgModal.vue'
import ApplyNow from '@/components/ApplyNow.vue'
import { swiper, swiperSlide } from "vue-awesome-swiper";
import moment from "moment";
import filter from "js/filter";
import echarts from "echarts";
export default {
  mixins: [userInfo, attention_mixins, attention_entity_mixins, collect_mixin],
  inject: ["haddleBackModel", "getNewVersionInfo"],
  data() {
    return {
      num_random: Math.floor(Math.random() * 3),
      // num_random: 3,
      first_open: true,
      filter: filter,
      // type_show: false,
      swiperOption: {
        autoplay: false,
        speed: 500,
        loop: false,
        slidesPerView: "auto",
        spaceBetween: 8,
        slidesPerGroup : 4,
        freeMode: true,
        navigation: {
          nextEl: ".next-btn",
          prevEl: ".prev-btn",
          disabledClass: "button-disabled"
        }
      },
      search_key: "",
      search_loading: true,
      search_list: [],
      search_list_show: false,
      hot_list: [],
      collect: [],
      org_top: [],
      event_domestic: 1,
      history_list: [],
      hotele: {},
      hotele_loading: true,
      hotele_time: "",
      dataChart: "",
      week_count: "",
      week_amount: "",
      feed_params: {
        has_select: 0,
        is_subscribe_all: 0, // 如果要搜索全部关注，has_select当置为0
        user_key: "",
        app_layer: [],
        comp: [],
        org: [],
        page: 1
      },
      feed_type: [],
      feed_list: [],
      show_ids: [],
      feed_loading: true,
      check_all: false,
      feed_end: false,
      select_identity: false,
      identity_cb: false,
      adv_list: [],
      flow: 0,
      chart_option: {
        tooltip: {
          trigger: "axis",
          backgroundColor: "#404040",
          padding: 12,
          formatter: function(params, ticket, callback) {
            var time = params[0].name,
              title = `<p class="p1">` + time + `</p>`,
              e_html =
                `<p class="p2"><i class="cir_i" style="background: linear-gradient(90deg,` +
                params[0].color.colorStops[0].color +
                ` 0%, ` +
                params[0].color.colorStops[1].color +
                ` 100%)"></i>事件数：<span>` +
                params[0].value +
                `起</span></p>`,
              r_html =
                `<p class="p2"><i class="cir_i" style="background: linear-gradient(90deg,` +
                params[1].color.colorStops[0].color +
                ` 0%, ` +
                params[1].color.colorStops[1].color +
                ` 100%)"></i>金额：<span>` +
                params[1].value +
                `亿人民币</span></p>`;

            return (
              `<div class="chart_tip">` + title + e_html + r_html + `</div>`
            );
          }
        },
        grid: {
          left: "6px",
          right: "6px",
          top: "60px",
          bottom: "0",
          containLabel: true
        },
        legend: {
          data: ["数量", "金额"],
          selectedMode: false,
          top: "0",
          left: "0",
          itemWidth: 10,
          itemHeight: 10,
          icon: "rect",
          textStyle: {
            color: "",
            fontSize: 12,
            lineHeight: 12
          }
        },
        xAxis: [
          {
            type: "category",
            data: [],
            boundaryGap: false,
            axisPointer: {
              type: "line",
              lineStyle: {
                color: ""
              }
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: ""
              }
            },
            axisLabel: {
              formatter: a => {
                return moment(a).format("MM-DD");
              },
              textStyle: {
                color: ""
              }
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            name: "数量",
            scale: true,
            splitNumber: 3,
            axisLabel: {
              formatter: "{value}",
              color: ""
            },
            splitLine: {
              lineStyle: {
                color: "",
                width: 1,
                type: "dashed"
              }
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: ""
              }
            },
            axisTick: {
              show: false
            },
            minInterval: 1
          },
          {
            type: "value",
            name: "金额(亿)",
            scale: true,
            splitNumber: 3,
            axisLabel: {
              formatter: "{value}",
              color: ""
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: ""
              }
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
            }
          }
        ],
        series: [
          {
            name: "数量",
            type: "line",
            smooth: true,
            itemStyle: {
              normal: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgba(76, 121, 254, 1)"
                    },
                    {
                      offset: 1,
                      color: "rgba(149, 176, 255, .5)"
                    }
                  ]
                }
              }
            },
            lineStyle: {
              normal: {
                width: 1
              }
            },
            areaStyle: {
              normal: {
                opacity: 0.9
              }
            },
            data: []
          },
          {
            name: "金额",
            type: "line",
            yAxisIndex: 1,
            smooth: true,
            itemStyle: {
              normal: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgba(79, 187, 251, 1)"
                    },
                    {
                      offset: 1,
                      color: "rgba(155, 217, 255, .5)"
                    }
                  ]
                }
              }
            },
            lineStyle: {
              normal: {
                width: 1
              }
            },
            areaStyle: {
              normal: {
                opacity: 0.9
              }
            },
            data: []
          }
        ]
      }
    };
  },
  computed: {
    theme_switch() {
      return this.$store.state.theme_switch;
    },
    static_img_url() {
      return this.$store.state.static_img_url;
    },
    atten_num() {
      return function(type) {
        let sub_arr = this.attention.subscribe || [];
        if (type == "all") {
          return sub_arr.length;
        } else {
          let arr = sub_arr.filter(a => a.sub_type == type);
          return arr.length;
        }
      };
    },
    group_num() {
      return function(g) {
        let g_arr = this.attention.g_relation || [];
        let arr = g_arr.filter(a => a.group_id == g);
        return arr.length;
      };
    },
    is_atten() {
      return function(id) {
        let index = this.attention.subscribe.findIndex(
          a => a.sub_type_id == id
        );
        return index > -1;
      };
    },
    all_option() {
      let option = [];
      this.feed_type.map(a => {
        if (a === "tag") {
          option.push({
            type: a,
            name: "关注的领域"
          });
        } else if (a === "comp") {
          option.push({
            type: a,
            name: "关注的公司"
          });
        } else if (a === "org") {
          option.push({
            type: a,
            name: "关注的机构"
          });
        } else if (a.split("|")[0] == "yz") {
          let yz_id = a.split("|")[1];
          let item = this.yz_group.find(item => item.id == yz_id);
          option.push({
            type: a,
            name: item.name
          });
        } else if (a.split("|")[0] == "g") {
          let id = a.split("|")[1];
          let item = this.attention.group.find(item => item.id == id);
          option.push({
            type: a,
            name: item.name
          });
        } else if (a.split("|")[0] == "zt") {
          let id = a.split("|")[1];
          let item = this.zt_list.find(item => item.id == id);
          option.push({
            type: a,
            name: item.name
          });
        }
      });
      if(this.check_all) {
        option.push({
          type: 'all',
          name: '全部关注'
        })
      }
      return [].concat(option);
    },
    never_xuser_type() {
      let user_info;
      if (this.user && typeof this.user == "string") {
        user_info = JSON.parse(this.user);
        if (user_info.xuser_type_id) {
          return false;
        } else {
          return true;
        }
      } else if (this.user && typeof this.user == "object") {
        if (this.user.xuser_type_id) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    never_subscribe() {
      if (this.$store.state.attention) {
        if (
          this.$store.state.attention.subscribe.filter(item => {
            return item.sub_type == "2";
          }).length == 0
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    is_show() {
      return function(content_id, content_type, c_id, date_day) {
        let index = this.show_ids.findIndex(item => item.content_id == content_id && item.content_type == content_type && item.c_id == c_id && item.date_day == date_day)
        return index > -1
      }
    },
    is_collect() {
      return function(id, type) {
        let arr = type == 0 ? this.topic_collect : this.policy_collect
        let index = arr.findIndex(item => item.content_id == id)
        return index > -1
      }
    },
    version_cb() {
      return this.$store.state.version_cb
    }
  },
  components: {
    SelectIdentity,
    Nothing,
    OrgModal,
    ApplyNow
  },
  methods: {
    clearIdentityModal(val) {
      if(!val) {
        document.body.style.paddingRight = ''
        document.body.style.overflow = ''
      }
    },
    attentionDelete(item_id) {
      layer.confirm(
        "确定不再关注？",
        {
          title: false,
          offset: "100px",
          skin: "layer-custom",
          btn: ["确定", "取消"] //按钮
        },
        () => {
          this.cancelEntity("cancel", item_id);
          layer.closeAll();
        },
        () => {
          layer.closeAll();
        }
      );
    },
    async getCollectionNum() {
      let res = await myCollectionNum(
        {
          user_key: this.user_key
        },
        error => {
          this.$Message.error("请求错误！");
        }
      );
      if (res.status == "success") {
        this.$set(this.$data, "collect", res.res);
      } else {
        this.$Message.error(res.message);
      }
    },
    changeCollect(item) {
      this.getCollectionNum()
      this.feed_list.map(a => {
        a.map(b => {
          if(b.content_id == item.id && b.content_type == item.type) {
            b.is_collect = item.status
          }
        })
      })
    },
    async getRecommendentity() {
      let res = await recommendEntity(
        {
          user_key: this.user_key
        },
        error => {
          this.$Message.error("请求错误！");
        }
      );
      if (res.status == "success") {
        let arr = [].concat(res.org, res.comp);
        arr.sort(() => (Math.random() > 0.5 ? 1 : -1));
        this.$set(this.$data, "hot_list", arr);
      } else {
        this.$Message.error(res.message);
      }
    },
    async getOrgTop() {
      let res = await getOrgTop(
        {
          user_key: this.user_key
        },
        error => {
          this.$Message.error("请求错误！");
        }
      );
      if (res.status == "success") {
        this.$set(this.$data, "org_top", res.res);
      } else {
        this.$Message.error(res.message);
      }
    },
    async getWeekEvent() {
      let res = await getWeekEvent({
        domestic: this.event_domestic
      }, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        let date_arr = [], count_arr = [], amount_arr = []
        let week_day = moment().day() == 0 ? moment().subtract(1, 'w').day(1) : moment().day(1)
        let i = 0
        while (i < 6){
          date_arr.push(moment(week_day).day(1 - 7*i).format('YYYY-MM-DD'))
          i++
        }
        date_arr.sort();
        date_arr.map((a, i) => {
          let index = res.res.findIndex(b => a == b.x_date);
          if (index > -1) {
            count_arr.push(res.res[index].event_count - 0);
            amount_arr.push(
              filter.amountChangeAveRate(
                res.res[index].event_amount,
                1,
                1,
                moment(a).year(),
                moment(a).year()
              )
            );
            if (i == 5) {
              this.week_count = res.res[index].event_count;
              this.week_amount = filter.amountChangeAveRate(
                res.res[index].event_amount,
                1,
                1,
                moment(a).year(),
                moment(a).year()
              );
            }
          } else {
            count_arr.push(0);
            amount_arr.push(0);
            if (i == 5) {
              this.week_count = 0;
              this.week_amount = 0;
            }
          }
        });
        this.chart_option.xAxis[0].data = date_arr;
        this.chart_option.series[0].data = count_arr;
        this.chart_option.series[1].data = amount_arr;
        this.chart_color();

        this.dataChart = echarts.init(
          document.getElementById("financing-chart")
        );
        this.dataChart.setOption(this.chart_option);
      } else {
        this.$Message.error(res.message);
      }
    },
    handleChangeDomestic(idx) {
      this.event_domestic = idx;
      this.getWeekEvent();
    },
    async handleChangeSearch() {
      this.search_loading = true;
      let res = await searchForEntity(
        {
          user_key: this.user_key,
          keyword: this.search_key
        },
        error => {
          this.$Message.error("请求错误！");
        }
      );
      if (res.status == "success") {
        this.$set(this.$data, "search_list", res.res);
        this.search_loading = false;
      } else {
        this.$Message.error(res.message);
      }
    },
    handleFocusSearch() {
      setTimeout(() => {
        this.search_list_show = false;
      }, 200);
    },
    async findEntity() {
      let his_arr = localStorage.history_entity
        ? JSON.parse(localStorage.history_entity)
        : [];
      let res = await findEntity(
        {
          ids: his_arr
        },
        error => {
          this.$Message.error("请求错误！");
        }
      );
      if (res.status == "success") {
        let arr = []
        his_arr.map(a => {
          let index = res.res.findIndex(b => b.id == a)
          if (index > -1) {
            arr.push(res.res[index])
          }          
        });
        this.$set(this.$data, 'history_list', arr)
      } else {
        this.$Message.error(res.message);
      }
    },
    async getHotele() {
      let res = await getHotele(
        {
          s_time: moment()
            .subtract(1, "months")
            .format("YYYY-MM-DD HH:mm")
        },
        error => {
          this.$Message.error("请求错误！");
        }
      );
      if (res.status == "success") {
        // localStorage.open_work_time = moment().format('YYYY-MM-DD HH:mm')
        this.hotele_loading = false;
        this.hotele = {
          event_num: res.event_num,
          news_topic_num: res.news_topic_num,
          report_num: res.report_num,
          theme_num: res.theme_num
        };
        this.$forceUpdate();
      } else {
        this.$Message.error(res.message);
      }
    },
    async getUserFeedData() {
      this.feed_loading = true;
      this.feed_params.user_key = this.user_key;
      let res = await userFeedData(this.feed_params, error => {
        this.$Message.error("请求错误！");
      });
      if (res.status == "success") {
        res.res.map(a => {
          this.feed_list.push(a);
        });
        this.feed_end = res.res.length < 10 ? true : false;
        this.feed_loading = false;
        this.$nextTick(() => {
          this.haddleScroll("left");
          this.haddleScroll("right");
        });
        this.$previewRefresh();
      } else {
        this.$Message.error(res.message);
      }
    },
    handleClickShow(content_id, content_type, c_id, date_day) {
      let index = this.show_ids.findIndex(item => item.content_id == content_id && item.content_type == content_type && item.c_id == c_id && item.date_day == date_day)
      if(index == -1) {
        this.show_ids.push({
          content_id: content_id,
          content_type: content_type,
          c_id: c_id,
          date_day: date_day
        })
      } else {
        this.show_ids.splice(index, 1)
      }
    },
    handleClickMoreFeed(c_id, card_type) {
      this.$router.push({
        name: "FeedList",
        query: { c_id: c_id, card_type: card_type }
      });
    },
    goAtten() {
      let a = this.feed_type[0]
      if (a === 'tag') {
        this.haddleSetAtten1()
      } else if (a === 'comp') {
        this.haddleSetAtten1(1, 'comp')
      } else if (a === 'org') {
        this.haddleSetAtten1(1, 'org')
      } else if (a.split('|')[0] == 'yz') {
        this.haddleSetAtten3(a.split('|')[1])
      } else if (a.split('|')[0] == 'g') {
        this.haddleSetAtten2(a.split('|')[1])
      }
    },
    handleMoreFeed() {
      if (!this.isVIP) {
        if(this.feed_params.page == 2) { // 非会员2页
          this.$refs['org_modal'].goShow()
          this.org_modal_img = 'cksl'
          this.org_modal_p = '如果您有需求，可联系我们工作人员'
        } else {
          this.feed_params.page++
          this.getUserFeedData()
        }
      } else {
        if(this.feed_params.page == 10) { // 会员10页
          this.$refs['org_modal'].goShow()
          this.org_modal_img = 'cksl'
          this.org_modal_p = '如果您有需求，可联系我们工作人员'
        } else {
          this.feed_params.page++
          this.getUserFeedData()
        }
      }
    },
    handleChangeType() {
      if (!this.feed_loading) {
        this.check_all = false;
        this.feed_params.app_layer = [];
        this.feed_params.comp = [];
        this.feed_params.org = [];

        this.feed_type.map(a => {
          if (a === "tag") {
            let arr = this.attention.subscribe.filter(b => b.sub_type == 2);
            arr.map(item => this.feed_params.app_layer.push(item.sub_type_id));
          } else if (a === "comp") {
            let arr = this.attention.subscribe.filter(b => b.sub_type == 0);
            arr.map(item => this.feed_params.comp.push(item.sub_type_id));
          } else if (a === "org") {
            let arr = this.attention.subscribe.filter(b => b.sub_type == 1);
            arr.map(item => this.feed_params.org.push(item.sub_type_id));
          } else if (a.split("|")[0] == "yz") {
            let yz_id = a.split("|")[1];
            let index = this.yz_group.findIndex(item => item.id == yz_id);
            if (index > -1) {
              this.yz_group[index].comp.map(item =>
                this.feed_params.comp.push(item)
              );
              this.yz_group[index].org.map(item =>
                this.feed_params.org.push(item)
              );
            }
          } else if (a.split("|")[0] == "g") {
            let g_id = a.split("|")[1];
            let sub_arr = this.attention.g_relation.filter(
              item => item.group_id == g_id
            );
            sub_arr.map(item => {
              let index = this.attention.subscribe.findIndex(
                prop => prop.id == item.subscribe_id
              );
              if (index > -1) {
                let obj = this.attention.subscribe[index];
                if (obj.sub_type == 0) {
                  this.feed_params.comp.push(obj.sub_type_id);
                } else if (obj.sub_type == 1) {
                  this.feed_params.org.push(obj.sub_type_id);
                } else if (obj.sub_type == 2) {
                  this.feed_params.app_layer.push(obj.sub_type_id);
                }
              }
            });
          } else if(a.split("|")[0] == 'zt') {
            let temp_obj = this.zt_list.find(z => z.id == a.split("|")[1])
            this.feed_params.comp = this.feed_params.comp.concat(temp_obj.entitys.filter(f => f.type == '0').map(f => f.id))
            this.feed_params.org = this.feed_params.org.concat(temp_obj.entitys.filter(f => f.type == '1').map(f => f.id))
            this.feed_params.app_layer = this.feed_params.app_layer.concat(temp_obj.entitys.filter(f => f.type == '2').map(f => f.id))
          }
        });

        if (this.feed_type.length > 0) {
          this.check_all = false;
          this.feed_params.has_select = 1;
          this.feed_params.is_subscribe_all = 0;
        } else {
          this.check_all = true;
          this.feed_params.has_select = 0;
          this.feed_params.is_subscribe_all = 1;
        }

        this.feed_list = [];
        this.feed_params.page = 1;
        this.getUserFeedData();
      } else {
        this.$Message.loading("数据正在加载中，请勿重复操作！");
      }
    },
    handleCheckAll() {
      if (this.check_all) {
        this.feed_type = [];
        this.handleChangeType();
      } else {
        this.carryClearFeed()
      }
    },
    carryClearFeed() {
      this.feed_params.app_layer = [];
      this.feed_params.comp = [];
      this.feed_params.org = [];
      this.feed_params.has_select = 0;
      this.feed_params.is_subscribe_all = 0;
      this.feed_list = [];
      this.feed_params.page = 1;
      this.getUserFeedData();
    },
    haddleCloseOpt(item) {
      if(item.type == 'all') {
        this.check_all = false
        this.carryClearFeed()
      } else {
        let index = this.feed_type.findIndex(a => item.type == a);
        if (index > -1) {
          this.feed_type.splice(index, 1);
        }
        this.handleChangeType();
      }
    },
    haddleClearOpt() {
      this.feed_type = [];
      this.check_all = false;
      this.carryClearFeed();
    },
    selectIdentity() {
      // 弹出框
      if (this.$store.state.user_key) {
        if (this.$store.state.current_app_identity_show != 0) {
          if (this.never_xuser_type) {
            this.flow = 0
            this.select_identity = !this.select_identity;
          } else {
            if (this.never_subscribe) {
              this.flow = 1
              this.select_identity = !this.select_identity;
            }
          }
        }
      }
    },
    identityCancel(refresh) {
      if (refresh) {
        this.identity_cb = true
        this.feed_list = [];
        this.feed_params.page = 1;
        this.getUserFeedData();
      }
    },
    chart_color() {
      this.chart_option.legend.textStyle.color = !this.theme_switch
        ? "rgba(233, 233, 235, 1)"
        : "rgba(51, 51, 51, 1)";
      this.chart_option.yAxis[0].splitLine.lineStyle.color = !this.theme_switch
        ? "rgba(64, 68, 79, 1)"
        : "rgba(233, 233, 233, 1)";
      this.chart_option.yAxis[0].axisLabel.color = !this.theme_switch
        ? "rgba(188, 189, 193, 1)"
        : "rgba(153, 153, 153, 1)";
      this.chart_option.yAxis[1].axisLabel.color = !this.theme_switch
        ? "rgba(188, 189, 193, 1)"
        : "rgba(153, 153, 153, 1)";
      this.chart_option.yAxis[0].axisLine.lineStyle.color = !this.theme_switch
        ? "rgba(188, 189, 193, 1)"
        : "rgba(153, 153, 153, 1)";
      this.chart_option.yAxis[1].axisLine.lineStyle.color = !this.theme_switch
        ? "rgba(188, 189, 193, 1)"
        : "rgba(153, 153, 153, 1)";
      this.chart_option.xAxis[0].axisLine.lineStyle.color = !this.theme_switch
        ? "rgba(64, 68, 79, 1)"
        : "rgba(233, 233, 233, 1)";
      this.chart_option.xAxis[0].axisLabel.textStyle.color = !this.theme_switch
        ? "rgba(233, 233, 235, 1)"
        : "rgba(51, 51, 51, 1)";
      this.chart_option.xAxis[0].axisPointer.lineStyle.color = !this
        .theme_switch
        ? "rgba(188, 189, 193, 1)"
        : "rgba(233, 233, 233, 1)";
    },
    goEntityDetail(uid, type) {
      if (type == 2) {
        const { href } = this.$router.resolve({
          name: "PeoDetail",
          params: { uid: uid }
        });
        window.open(href, "_blank");
      } else if (type == 1) {
        const { href } = this.$router.resolve({
          name: "OrgDetail",
          params: { uid: uid }
        });
        window.open(href, "_blank");
      } else if (type == 0) {
        const { href } = this.$router.resolve({
          name: "CompanyDetail",
          params: { uid: uid }
        });
        window.open(href, "_blank");
      } else if (type == 3) {
        const { href } = this.$router.resolve({
          name: "HospitalDetail",
          params: { uid: uid }
        });
        window.open(href, "_blank");
      }
    },
    goDetail(uid, type, src, id) {
      if (type == 0) {
        const { href } = this.$router.resolve({
          name: "NewsDetail",
          params: { uid: uid }
        });
        window.open(href, "_blank");
      } else if (type == 1) {
        const { href } = this.$router.resolve({
          name: "ReportDetail",
          params: { uid: uid }
        });
        window.open(href, "_blank");
      } else if (type == 2) {
        const { href } = this.$router.resolve({
          name: "SpecialDetail",
          params: { uid: uid }
        });
        window.open(href, "_blank");
      } else if (type == 3) {
        const { href } = this.$router.resolve({
          name: "PolicyDetail",
          params: { uid: uid }
        });
        window.open(href, "_blank");
      } else if (type == 4) {
        window.open(this.$store.state.index2_path + '/' + id);
      } else if (type == 5) {
        window.open(filter.page(src), "_blank");
      }
    },
    handleChangeRouter(router_name, router_query) {
      this.$router.push({ name: router_name, query: router_query });
    },
    handleOpenRouter(router_name, router_query) {
      const { href } = this.$router.resolve({
        name: router_name,
        query: router_query
      });
      window.open(href, "_blank");
    },
    async getAdvList() {
      let res = await advList(
        {
          adv_pos_id: [38, 39]
        },
        error => {
          this.$Message.error("请求错误！");
        }
      );
      if (res.status == "success") {
        this.$set(this.$data, "adv_list", res.res);
      } else {
        this.$Message.error(res.message);
      }
    },
    haddleScroll(item) {
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop; //滚动条的值

      let bottom =
        scrollTop + window.innerHeight - $(".footer").offset().top + 32;
      if (
        $(".content-left").height() + 1 >= $(".bench-left").height() ||
        $(".content-right").height() + 1 >= $(".bench-right").height()
      ) {
        $(".content-" + item).addClass("content-status-2");
      } else {
        $(".content-" + item).removeClass("content-status-2");
        if (bottom > -1) {
          $(".content-" + item).css(
            "transform",
            "translateY(-" + bottom + "px)"
          );
        } else {
          $(".content-" + item).css("transform", "translateY(0)");
        }
      }
      if (
        scrollTop + window.innerHeight >=
        $(".content-" + item).height() + 108
      ) {
        $(".content-" + item).addClass("content-status-1");
        if ($(".content-" + item).height() < window.innerHeight - 108) {
          $(".content-" + item).addClass("content-status-3");
        } else {
          $(".content-" + item).removeClass("content-status-3");
        }
      } else {
        $(".content-" + item).removeClass("content-status-1");
      }
    },
    handleHotAtten(item, index) {
      this.attentionAdd(item.id, item.type, "", () => {
        this.hot_list.splice(index, 1);
      });
    },
    handleZtAtten(item, index) {
      this.attentionAdd(item.id, '100', "", () => {
        this.refreshZtList()
      });
    },
    haddleShare(uid, type) {
      let share_link
      if(type == 0) {
        share_link = this.$store.state.index2_path + '/News/newsDetail?uid=' + uid
      } else {
        share_link = this.$store.state.index_path + '/policyDetail/' + uid
      }
      jQuery($('.share_img')).qrcode({
        width: 80,
        height: 80,
        correctLevel: 0,
        text: share_link
      })
      _czc.push(['_trackEvent', '动脉橙首页快讯', '快讯列表页分享入口'])
    },
    haddleShareHide() {
      $('.share_img').html('')
    }
  },
  created() {
    // this.first_open = localStorage.open_work_time ? false : true
    // this.hotele_time = localStorage.open_work_time ? localStorage.open_work_time : moment().subtract(1, 'months').format('YYYY-MM-DD HH:mm')
    this.getMeta()
    this.getCollectionNum();
    this.getRecommendentity();
    this.getOrgTop();
    this.getWeekEvent();
    this.findEntity();
    this.getHotele();
    this.getAdvList();
    this.getUserFeedData();
  },
  mounted() {
    this.$nextTick(() => {
      this.getNewVersionInfo()
      window.onresize = () => {
        this.haddleScroll("left");
        this.haddleScroll("right");
      };
      window.onscroll = () => {
        this.haddleScroll("left");
        this.haddleScroll("right");
      };
    });
  },
  destroyed() {
    window.onscroll = "";
    window.onresize = "";
  },
  watch: {
    theme_switch(val) {
      this.chart_color();
      this.dataChart.setOption(this.chart_option, true);
    },
    version_cb(val) {
      if(val) {
        this.selectIdentity()
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
.work-bench
  padding 24px 0 52px
  width 1200px
  margin 0 auto
  display flex
  p, .bench
    &-page
      padding 20px
      commonBgColor(rgba(31, 35, 48, 1), rgba(255, 255, 255, 1))
      h1
        font-size 20px
        font-weight 600
        commonColor(rgba(255, 255, 255, 1), rgba(0, 0, 0, 1))
        i
          margin-top 8px
          font-style normal
          float right
          font-size 12px
          font-weight 400
          commonColor(rgba(121, 123, 131, 1), rgba(153, 153, 153, 1))
      &+.bench-page
        margin-top 16px
    &-left
      flex 0 0 242px
      .attention-list
        margin-top 18px
        overflow-y auto
        max-height 354px
        >.ivu-checkbox-wrapper
          margin-top 0 !important
        .ivu-checkbox-wrapper
          display flex
          font-size 0
          margin-top 10px
          & >>> .ivu-checkbox
            font-size 0
            margin-right 8px
            .ivu-checkbox-inner
              margin-top 1px
              display inline-block
              vertical-align top
              background transparent
              commonBorderColor(#7A7F94, rgba(213, 213, 213, 1))
              &::after
                border-color #fff
              &.ivu-checkbox-focus
                box-shadow none
            &:hover
              .ivu-checkbox-inner
                commonBorderColor(rgba(250, 122, 80, 1), rgba(35, 41, 77, 1))
            &.ivu-checkbox-checked
              .ivu-checkbox-inner
                commonBorderColor(rgba(250, 122, 80, 1), rgba(35, 41, 77, 1))
                commonBgColor(rgba(250, 122, 80, 1), rgba(35, 41, 77, 1))
          span.ivu-checkbox+*
            display inline-block
            line-height 18px
            font-size 13px
            commonColor(#BCBDC1, #333333)
            vertical-align top
            margin 0
            &:hover
              color rgba(250, 122, 80, 1) !important
        .more_sel
          display inline-block
          margin-top 10px
          cursor pointer
          font-size 13px
          commonColor(#BCBDC1, #333333)
          text-decoration underline
          &:hover
            color rgba(250, 122, 80, 1) !important
      .add-atten
        border-radius 4px
        display block
        width 100%
        color rgba(250, 122, 80, 1)
        line-height 34px
        text-align center
        margin-top 20px
        margin-bottom -4px
        font-size 12px
        commonBgColor(rgba(42, 47, 66, 1), rgba(255, 245, 242, 1))
        &:hover
          background-color rgba(250, 122, 80, 1)
          color rgba(255, 255, 255, 1)
        i
          font-size 12px
          display inline-block
          vertical-align top
          margin-left 5px
      .collect-list
        margin-top 18px
        display grid
        grid-template-columns 1fr 1fr 1fr
        grid-gap 20px 6px
        > div
          text-align center
          font-size 0
          img
            width 40px
            height 40px
            cursor pointer
          p
            font-size 13px
            margin-top 8px
            commonColor(rgba(233, 233, 235, 1), rgba(51, 51, 51, 1))
            cursor pointer
            span
              commonColor(rgba(121, 123, 131, 1), rgba(121, 123, 131, 1))
          &:hover
            p
              color rgba(250, 122, 80, 1)
              span
                color rgba(250, 122, 80, 1)
      .history
        margin-top 18px
        &-item
          display flex
          .logo_img
            flex 0 0 44px
            height 44px
            line-height 42px
            cursor pointer
            border-radius 2px
          .entity-name
            padding-left 6px
            flex auto
            color rgba(51, 51, 51, 1)
            commonColor(rgba(233, 233, 235, 1), rgba(51, 51, 51, 1))
            line-height 18px
            display flex
            align-items center
            cursor pointer
            &:hover
              color rgba(250, 122, 80, 1)
          &+div
            margin-top 15px
        &-none
          commonColor(rgba(233, 233, 235, 1), rgba(121, 123, 131, 1))
          span
            cursor pointer
            color rgba(250, 122, 80, 1)
            text-decoration underline
            &:hover
              color rgba(252, 156, 124, 1)
    &-center
      flex auto
      margin 0 16px
      .hot-list
        position relative
        margin-top 25px
        .swiper-container
          width 598px
          margin-left -4px
          z-index 0
          .swiper-slide
            padding 4px 4px 18px
            width 128px
          .hot-item
            width 120px
            height 154px
            commonBgColor(rgba(31, 34, 47, 1), rgba(255, 255, 255, 1))
            commonShadow(0px 2px 8px 0px rgba(0, 0, 0, 0.6), 0px 1px 4px 0px rgba(0, 0, 0, 0.1))
            padding 16px
            position relative
            .hot-i
              border-top 12px solid #F94848
              border-right 12px solid #F94848
              border-bottom 12px solid transparent
              border-left 12px solid transparent
              width 0
              height 0
              position absolute
              right 0
              top 0
              i
                color #fff
                font-size 12px
                position absolute
                top -11px
                right -11px
            .logo_img
              border 0
              width 88px
              height 88px
              line-height 88px
              cursor pointer
            .name
              width 88px
              height 18px
              font-size 14px
              font-weight 400
              commonColor(rgba(233, 233, 235, 1), rgba(51, 51, 51, 1))
              line-height 18px
              text-align center
              ellipsis()
              margin-top 6px
              cursor pointer
            .summary
              padding 22px 16px
              commonBgColor(#2A2F42, #FC9C7C)
              position absolute
              width 100%
              height 100%
              overflow-y auto
              left 0
              top 0
              opacity 0
              transform translate3d(0, 50px, 0)
              transition all 0.5s
              display flex
              flex-direction column
              align-items center
              justify-content center
              > p
                width 100%
                font-size 14px
                font-weight 400
                commonColor(#e9e9eb, rgba(255, 255, 255, 1))
                line-height 20px
                max-height 80px
                ellipsisClamp2()
                -webkit-line-clamp 4
                text-align center
              > div
                commonColor(#FA7A50, #333)
                margin-top 4px 
                line-height 18px
                cursor pointer
                text-decoration underline
                &:hover
                  commonColor(#fc9c7c, #333)
            &:hover
              .summary
                opacity 1
                transform translate3d(0, 0, 0)
            .ivu-btn
              position absolute
              width 88px
              height 28px
              commonBgColor(rgba(42, 47, 66, 1), rgba(255, 245, 242, 1))
              commonShadow(0px 2px 8px 0px rgba(0, 0, 0, 0.3), 0px 1px 4px 0px rgba(211, 81, 38, 0.15))
              border-radius 2px
              font-size 12px
              font-weight 400
              color rgba(250, 122, 80, 1)
              border 0
              bottom -14px
              left 16px
              &:hover
                background-color rgba(250, 122, 80, 1)
                color rgba(255, 255, 255, 1)
              &.on
                background-color rgba(250, 122, 80, 1)
                color rgba(255, 255, 255, 1)
        .prev-btn, .next-btn
          position absolute
          right 0
          top 0
          z-index 0
          width 16px
          height 176px
          box-shadow none !important
          button
            position absolute
            top 50%
            right 8px
            margin-top -16px
            width 32px
            height 32px
            background rgba(250, 122, 80, 0.9)
            box-shadow 0px 6px 12px -6px rgba(250, 122, 80, 0.8)
            padding 0
            border 0
            border-radius 50%
            z-index 2
            i
              font-size 12px
              color #fff
          &.button-disabled
            display none
          .hot-msk
            position absolute
            right 0
            top 0
            width 16px
            height 176px
            z-index 1
            commonBgColor(linear-gradient(90deg, rgba(31, 34, 47, 0) 0%, rgba(31, 35, 48, 1) 100%), linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%))
            box-shadow none !important
        .prev-btn
          right auto
          left -4px
          button
            right auto
            left 8px
          .hot-msk
            right auto
            left 0
            commonBgColor(linear-gradient(270deg, rgba(31, 34, 47, 0) 0%, rgba(31, 35, 48, 1) 100%), linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%))
      .search-ipt
        margin-top 10px
        position relative
        >>> .ivu-input
          border 0
          border-radius 0
          border-bottom 1px solid
          commonBorderColor(rgba(64, 68, 79, 1), rgba(241, 241, 241, 1))
          line-height 18px
          padding 4px 6px 4px 26px
          font-size 14px
          background-color transparent
          commonColor(rgba(188, 189, 193, 1), rgba(51, 51, 51, 1))
          &::-webkit-input-placeholder
            commonColor(#797B83, rgba(170, 170, 170, 1))
          &::-moz-input-placeholder
            commonColor(#797B83, rgba(170, 170, 170, 1))
          &:-ms-input-placeholder
            commonColor(#797B83, rgba(170, 170, 170, 1))
          &:focus
            box-shadow none
            border-color rgba(250, 122, 80, 1)
        >>> .ivu-input-prefix
          width 16px
          i
            font-size 16px
            commonColor(#797B83, rgba(204, 204, 204, 1))
        .search-list
          position absolute
          width 100%
          z-index 5
          padding 20px 0
          p
          commonBgColor(rgba(31, 35, 48, 1), rgba(255, 255, 255, 1))
          commonShadow(0px 4px 20px 0px rgba(0, 0, 0, 0.6), 0px 4px 20px 0px rgba(0, 0, 0, 0.15))
          .nothing
            text-align center
            font-size 0
            commonBgColor(#1f2330, #FFFFFF)
            padding 60px 0
            .img
              display inline-block
              vertical-align top
              width 187px
              height 116px
              commonBgImg('~pic/no-search.png', '~pic/no-search2.png')
              background-size 100% !important
              background-repeat no-repeat !important
            p
              commonColor(#797b83, #333333)
              font-size 14px
              margin-top 16px
              line-height 24px
              span
                color rgba(250, 122, 80, 1)
                cursor pointer
                &:hover
                  color rgba(252, 156, 124, 1)
          .search-tip
            padding 0 20px
            commonColor(rgba(233, 233, 235, 1), rgba(121, 123, 131, 1))
          .search-cnt
            max-height 252px
            overflow-y auto
            padding 0 20px
          .search-item
            display flex
            &+.search-item
              margin-top 8px
            .logo_img
              flex 0 0 44px
              height 44px
              line-height 42px
            .entity-name
              padding-left 8px
              flex auto
              display flex
              align-items center
              cursor pointer
              &:hover
                .p1
                  color rgba(250, 122, 80, 1) !important
              .p1
                font-size 16px
                commonColor(rgba(233, 233, 235, 1), rgba(51, 51, 51, 1))
                line-height 18px
                >>> i.high-light
                  font-style normal
                  color rgba(250, 122, 80, 1)
              .p2
                font-size 14px
                commonColor(rgba(153, 153, 153, 1), rgba(153, 153, 153, 1))
                margin-top 3px
                max-width 438px
                ellipsis()
            &+div
              margin-top 15px
      .my-feed
        h1
          font-size 20px
          font-weight 600
          commonColor(rgba(255, 255, 255, 1), rgba(0, 0, 0, 1))
          margin-bottom 12px
        > div+div
          margin-top 16px
        .feed-item
          padding 20px 20px 0
          commonBgColor(rgba(31, 35, 48, 1), rgba(255, 255, 255, 1))
          position relative
          .feed-top
            display flex
            padding-right 100px
            .logo_img
              flex 0 0 44px
              height 44px
              line-height 42px
              cursor pointer
            .feed-info
              padding-left 10px
              padding-top 2px
            .feed-name
              font-size 18px
              font-weight 600
              color rgba(250, 122, 80, 1)
              cursor pointer
            .feed-time
              font-size 12px
              font-weight 400
              commonColor(rgba(121, 123, 131, 1), rgba(153, 153, 153, 1))
              margin-top 10px
          .feed-tool
            position absolute
            right 20px
            top 21px
            cursor pointer
            &:hover
              >>> .ivu-tooltip-rel
                i
                  color rgba(250, 122, 80, 1) !important
            >>> .ivu-tooltip-popper
              transform translateY(-6px)
            >>> .ivu-tooltip-rel
              i
                commonColor(rgba(255, 255, 255, 1), rgba(35, 41, 77, 1))
            >>> .ivu-tooltip-content
              .ivu-tooltip-arrow
                border-bottom-color #fff
              .ivu-tooltip-inner
                background-color #fff
                font-size 0
                min-height auto
                padding 0
                .atten
                  padding 6px 8px
                  .spa2
                    color #333 !important
                    i
                      font-size 13px
                      margin-top 0
          .span.spa1
            font-size 13px
            position absolute
            right 20px
            top 23px
            cursor pointer
            i
              font-size 12px
              vertical-align top
              display inline-block
              margin-top 1px
              margin-right 2px
            &.spa1
              color rgba(250, 122, 80, 1)
              i
                color rgba(250, 122, 80, 1)
              &:hover
                color rgba(252, 156, 124, 1)
                i
                  color rgba(252, 156, 124, 1)
          .feed-list
            width 594px
            margin-top 4px
            .feed-li
              padding 16px 0
              border-bottom 1px solid
              commonColor(rgba(64, 68, 79, 1), rgba(243, 243, 243, 1))
              &:last-of-type
                border-bottom 0
            .feed-type-1
              display flex
              .info-img
                flex 0 0 122px
                position relative
                height 76px
                overflow hidden
                cursor pointer
                &:hover
                  img
                    transform scale(1.2, 1.2)
                img
                  display block
                  width 100%
                  height 100%
                  cursor pointer
                  transition all 0.2s
                span
                  position absolute
                  background-color rgba(55, 55, 55, 0.8)
                  color #fff
                  width 32px
                  height 18px
                  text-align center
                  line-height 18px
                  font-size 12px
                  left 0
                  top 0
                  z-index 2
              .info-content
                flex auto
                display flex
                align-items center
                padding-left 7px
                .p1
                  font-size 14px
                  font-weight 400
                  commonColor(rgba(233, 233, 235, 1), rgba(51, 51, 51, 1))
                  line-height 20px
                  max-height 40px
                  ellipsisClamp2()
                  cursor pointer
                  &:hover
                    color rgba(250, 122, 80, 1)
                .p2
                  margin-top 9px
                  font-size 12px
                  font-weight 400
                  commonColor(rgba(188, 189, 193, 1), rgba(153, 153, 153, 1))
                  line-height 17px
                  max-height 17px
                  ellipsisClamp2()
                  -webkit-line-clamp 1
            .feed-type-2
              display flex
              .tag
                flex 0 0 32px
                height 18px
                text-align center
                line-height 18px
                font-size 12px
                margin-top 2px
                margin-right 6px
                &.tag1
                  commonBgColor(rgba(45, 61, 91, 1), rgba(236, 245, 255, 1))
                  color rgba(64, 158, 255, 1)
                &.tag2
                  commonBgColor(rgba(84, 51, 51, 1), rgba(254, 237, 237, 1))
                  color rgba(249, 102, 99, 1)
              .topic-type
                white-space nowrap
                font-size 14px
                line-height 22px
                margin-right 13px
                position relative
                commonColor(rgba(233, 233, 235, 1), rgba(51, 51, 51, 1))
                &:before
                  content ''
                  position absolute
                  width 1px
                  height 13px
                  commonBgColor(#40444f, rgba(233, 233, 233, 1))
                  right -7px
                  top 2px
                i
                  font-style normal
                  &+i
                    margin-left 6px
              p
                commonColor(rgba(233, 233, 235, 1), rgba(51, 51, 51, 1))
                flex auto
                font-size 14px
                line-height 22px
                max-height 22px
                ellipsis()
                cursor pointer
                &:hover
                  color rgba(250, 122, 80, 1)
                  .topic-type
                    color rgba(250, 122, 80, 1)
                    &:before
                      background-color rgba(250, 122, 80, 1)
                &.on
                  max-height none
                  font-weight bold
                  white-space normal
                  text-overflow inherit
                  word-break break-all
              .show-tag
                white-space nowrap
                font-size 12px
                color #FA7A50
                line-height 22px
                margin-left 10px
                cursor pointer
                i
                  font-size 12px
                  display inline-block
                  vertical-align: top
                  margin-left 4px
                &:hover
                  color #FC9C7C
            .show-all
              position relative
              .spa
                font-size: 12px
                padding-right: 25px
                commonColor(#797b83, #999999)
                text-align right
                &.on
                  position: absolute
                  right: 0
                  bottom: 0
                i
                  width: 18px;
                  height: 18px;
                  text-align: center;
                  line-height: 18px;
                  commonColor(#ADAFB4, #cccccc)
                  commonBgColor(#343844,#f3f3f3)
                  border-radius:2px;
                  font-size: 10px;
                  display: inline-block;
                  cursor: pointer;
                  &.s:hover,&.s.active
                    color: #fff;
                    background:rgba(250, 122, 80, 1);
                  &.w:hover,&.w.active
                    color: #fff;
                    background:#63BF61;
                & >>> .ivu-poptip
                  position: absolute
                  width: 18px
                  height: 18px
                  right: 0
                  // top: 2px
                  .ivu-poptip-rel
                    position: absolute
                    width: 18px
                    height: 18px
                    border-radius: 2px
                    right: 0
                    top: 0
                    cursor: pointer
                  .ivu-poptip-popper
                    transform: translate(13px, 0)
                    .ivu-poptip-inner
                      border-radius: 0
                      .share_cnt
                        padding: 10px 20px 10px 10px
                        .share_img
                          width: 80px
                          height: 80px
                          float: left
                          background: #f0f0f0
                        p
                          line-height: 20px
                          color: #666
                          float: right
                          margin-top: 20px
                          font-size: 14px
            .f-cnt
              margin-top 6px
              commonColor(#BCBDC1, #666)
              font-size 14px
              line-height 24px
              span
                margin-right 6px
            .policy-items
              padding 10px 0
              display grid
              grid-template-columns repeat(2, 1fr)
              grid-gap 2px
              .policy-item
                commonColor(#BCBDC1, #666666)
                font-size 14px
                display flex
                line-height:24px
                > div:nth-child(1)
                  white-space nowrap
            a.src-link
              white-space nowrap
              font-size 14px
              color #FA7A50
              cursor pointer
              i
                font-size 12px
                display inline-block
                vertical-align: top
                margin-top 1px
              &:hover
                color #FC9C7C
            .div-img
              margin-top 6px
              font-size 0
              line-height 1
              img
                max-width 160px
                max-height 80px
                cursor pointer
              img+img
                margin-left 8px
            .tag-list
              font-size 12px
              position relative
              color rgba(250, 122, 80, 1)
              line-height 18px
              padding-right 60px
              span
                cursor pointer
                margin 0 4px
                &:hover
                  color #FC9C7C
              i.iconfont
                font-size 12px
                margin-right 3px
                color rgba(250, 122, 80, 1)
          .more
            border-top 1px solid
            commonBorderColor(rgba(64, 68, 79, 1), rgba(243, 243, 243, 1))
            padding 16px 0 20px
            commonColor(rgba(255, 255, 255, 1), #333)
            cursor pointer
            font-size 14px
            i
              font-size 12px
              display inline-block
              margin-left 4px
            &:hover
              color rgba(250, 122, 80, 1)
        .feed-adv
          margin-bottom 16px
          position relative
          cursor pointer
          display block
          span
            position absolute
            background-color rgba(55, 55, 55, 0.8)
            color #fff
            width 32px
            height 18px
            text-align center
            line-height 18px
            font-size 12px
          img
            width 100%
            height 60px
            display block
        .feed-more
          width 100%
          height 34px
          line-height 34px
          text-align center
          font-size 14px
          font-weight 400
          color rgba(255, 136, 36, 1)
          cursor pointer
          commonBgColor(rgba(42, 47, 66, 1), rgba(255, 245, 242, 1))
          &:hover
            background-color rgba(250, 122, 80, 1)
            color rgba(255, 255, 255, 1)
    &-right
      flex 0 0 292px
      h1.financing-title
        font-weight 400
        commonColor(rgba(188, 189, 192, 1), rgba(102, 102, 102, 1))
        span
          display inline-block
          vertical-align top
          padding-bottom 4px
          border-bottom 2px solid transparent
          cursor pointer
          &.on
            commonColor(rgba(255, 255, 255, 1), rgba(0, 0, 0, 1))
            font-weight 600
            border-color rgba(250, 122, 80, 1)
          &:hover
            color rgba(250, 122, 80, 1)
            &.on
              commonColor(rgba(255, 255, 255, 1), rgba(0, 0, 0, 1))
          &+span
            margin-left 20px
        em
          margin-top 8px
          font-size 12px
          float right
          cursor pointer
          color rgba(250, 122, 80, 1)
          &:hover
            color rgba(252, 156, 124, 1)
            i
              color rgba(252, 156, 124, 1)
          i
            margin-top 0
            float none
            margin-left 4px
            font-size 12px
            color rgba(250, 122, 80, 1)
      .financing
        margin-top 16px
        z-index 3
        &-info
          i
            font-size 12px
            color rgba(250, 122, 80, 1)
            display inline-block
            vertical-align top
            margin-right 4px
            margin-top 1px
          span
            font-size 12px
            line-height 14px
            commonColor(rgba(233, 233, 235, 1), rgba(51, 51, 51, 1))
            display inline-block
            vertical-align top
            &+span
              margin-left 8px
        &-chart
          margin-top 12px
          height 160px
        >>> .chart_tip
          line-height 1
          p+p
            margin-top 8px
          .p1
            color #fff
            font-size 12px
          .p2
            font-size 12px
            color #C8C8C8
            span
              color #fff
            .cir_i
              display inline-block
              width 8px
              height 8px
              vertical-align top
              margin-top 2px
              border-radius 50%
              margin-right 6px
      .star
        margin-top 18px
        &-item
          display flex
          position relative
          &:nth-of-type(1), &:nth-of-type(2), &:nth-of-type(3)
            &:before
              content ''
              position absolute
              width 20px
              height 20px
              background url('~pic/work/top1.png') no-repeat 0 0
              background-size 20px 20px
              left -11px
              top -10px
          &:nth-of-type(2):before
            background-image url('~pic/work/top2.png')
          &:nth-of-type(3):before
            background-image url('~pic/work/top3.png')
          .logo_img
            flex 0 0 44px
            height 44px
            line-height 42px
            cursor pointer
            border-radius 2px
            cursor pointer
          .entity-name
            padding-left 6px
            flex auto
            commonColor(rgba(233, 233, 235, 1), rgba(51, 51, 51, 1))
            line-height 18px
            display flex
            align-items center
            cursor pointer
            font-size 13px
            &:hover
              color rgba(250, 122, 80, 1)
          .num
            display flex
            align-items center
            justify-content flex-end
            commonColor(rgba(233, 233, 235, 1), rgba(51, 51, 51, 1))
            flex 0 0 60px
            font-size 13px
          &+div
            margin-top 20px
        .more
          border-radius 4px
          display block
          width 100%
          color rgba(250, 122, 80, 1)
          line-height 34px
          text-align center
          margin-top 20px
          margin-bottom -4px
          font-size 12px
          commonBgColor(rgba(42, 47, 66, 1), rgba(255, 245, 242, 1))
          &:hover
            background-color rgba(250, 122, 80, 1)
            color rgba(255, 255, 255, 1)
          i
            font-size 12px
            display inline-block
            vertical-align top
            margin-left 5px
      .recent-hot
        margin-top 2px
        height 154px
        position relative
        display grid
        grid-template-columns 1fr 1fr
        &-item
          padding 15px
          text-align center
          position relative
          &:nth-of-type(1), &:nth-of-type(2)
            &:before
              content ''
              position absolute
              width 118px
              height 1px
              commonBgColor(rgba(64, 68, 79, 1), rgba(241, 241, 241, 1))
              bottom -1px
              left 0
          &:nth-of-type(1), &:nth-of-type(3)
            &:after
              content ''
              position absolute
              width 1px
              height 60px
              commonBgColor(rgba(64, 68, 79, 1), rgba(241, 241, 241, 1))
              top 8px
              right 0
          &:nth-of-type(2)
            &:before
              left auto
              right 0
          &:nth-of-type(3)
            &:after
              top auto
              bottom 8px
          .p1
            font-size 24px
            color rgba(250, 122, 80, 1)
            line-height 29px
          .p2
            font-size 13px
            font-weight 400
            commonColor(rgba(233, 233, 235, 1), rgba(51, 51, 51, 1))
            line-height 18px
            cursor pointer
            &:hover
              color rgba(250, 122, 80, 1)
.sel_opt
  margin-bottom 16px
  display flex
  .sel_cnt
    flex auto
    margin-bottom -12px
    span
      display inline-block
      font-size 12px
      line-height 1
      margin-right 8px
      cursor pointer
      border-radius 2px
      padding 6px 6px 6px 8px
      margin-bottom 8px
      commonColor(rgba(188, 189, 193, 1), #666)
      commonBgColor(rgba(31, 35, 48, 1), rgba(255, 255, 255, 1))
      i
        display inline-table
        vertical-align top
        margin-left 6px
        commonColor(rgba(188, 189, 193, 1), #aaa)
      &:hover
        color rgba(250, 122, 80, 1)
        i
          color rgba(250, 122, 80, 1)
  .sel_clear
    flex 0 0 80px
    line-height 24px
    text-align right
    span
      color rgba(250, 122, 80, 1)
      font-size 12px
      cursor pointer
      i.iconfont
        vertical-align top
        display inline-block
        font-size 12px
        margin-right 4px
      &:hover
        color rgba(252, 156, 124, 1)
.atten
  display flex
  align-items center
  justify-content flex-end
  flex 0 0 60px
  span
    font-size 13px
    cursor pointer
    i
      font-size 12px
      vertical-align top
      display inline-block
      margin-top 1px
      margin-right 2px
    &.spa1
      color rgba(250, 122, 80, 1)
      i
        color rgba(250, 122, 80, 1)
      &:hover
        color rgba(252, 156, 124, 1)
        i
          color rgba(252, 156, 124, 1)
    &.spa2
      commonColor(rgba(188, 189, 193, 1), rgba(51, 51, 51, 1))
      i
        color #49b580
  .cancel
    & >>> .ivu-select-dropdown
      border-radius 0
      padding 0
      commonBgColor(#2D2F34, #FFFFFF)
      commonShadow(0 4px 20px 0 rgba(0, 0, 0, 0.5), 2px 4px 20px 0 rgba(121, 133, 143, 0.2))
      .ivu-dropdown-menu
        min-width: 86px
      .ivu-dropdown-item
        line-height 1
        padding 12px 16px
        commonColor(rgba(255, 255, 255, 0.9), #333333)
        &:hover
          commonColor(rgba(255, 255, 255, 0.9), rgba(250, 122, 80, 1))
          commonBgColor(#35383F, #FFFFFF)
.content-left
  width 242px
.content-right
  width 292px
  z-index 5
.content-status-1
  position fixed
  bottom 20px
  &.content-status-2
    position inherit
  &.content-status-3
    top 88px
    bottom auto
.search-loading, .feed-loading
  position relative
  height 34px
  width 100%
  > .ivu-spin-fix
    background none
.identity-cb
  >>> .ivu-modal-wrap
    display: flex
    align-items: center
    .ivu-modal
      top: auto
  >>> .ivu-form-item-error-tip
    padding-top: 3px
    color: #FC3B3B
  >>> .ivu-modal-close
    top: 10px
  >>> .ivu-modal
    .ivu-modal-content
      border-radius: 0
      background-clip: initial
      .content
        text-align center
        padding 30px 0 10px
        img
          margin-left 8px
        .p1
          font-size 24px
          color #18C584
          margin-top 10px   
          font-weight bold
          line-height 1
        .p2                                 
          color #666666
          margin-top 16px
        span                  
          display inline-block
          vertical-align top
          width 150px
          height 40px
          background rgba(250,122,80,1)
          border-radius 20px
          text-align center
          line-height 40px
          color #fff
          font-size 16px
          cursor pointer
          margin-top 56px
          &:hover
            background rgba(252, 156, 124, 1)
</style>
